import React from 'react'
import {Box, Text} from '@chakra-ui/react'
import {useTranslation} from 'react-i18next'

import {AttentionIconWarning} from '../../../../../icons'
import {useAcquisitionDecision} from '../../../../../hooks/useAcquisitionDecision'
import PendingReasons from '../../../../../components/PendingReasons'

const PendingReasonsCard = () => {
  const {t} = useTranslation('onboarding')
  const {data, isLoading} = useAcquisitionDecision()

  return (
    <Box
      bg="mld.warning.100"
      p="md"
      my="md"
      border="1px solid"
      borderColor="neutral.glitter"
      borderRadius="lg"
      display="flex"
      alignItems="flex-start"
    >
      <Box mr="md">
        <AttentionIconWarning width="1.5em" height="1.5em" />
      </Box>
      <Box flex="1">
        <Box pb="md" textStyle="body-intro-medium">
          {t('onboarding:AcquisitionDecisionPending.accordionButtonLabel')}
        </Box>
        <Box textStyle="body-small">
          {!isLoading && (
            <PendingReasons pendingReasonKeys={data.pendingReasonKeys} />
          )}
        </Box>
        <Text textStyle="body-small">
          {t('onboarding:AcquisitionDecisionPending.accordionPanelFooter')}
        </Text>
      </Box>
    </Box>
  )
}

export default PendingReasonsCard
